import 'leaflet/dist/leaflet.css'
import './css/flightmap.css'
import { InitProps } from './types'
import { createElement } from './utils'
import { FlightViewMapLibTracker } from './tracker'
import { FlightViewMapLibATM } from './atm'
import { FlightViewMapLibWL } from './wl'
import { fvAtmInitSignal, fvWlInitSignal } from './AccessEvent'
import { initializeTranslations } from './i18n'
import { FlightViewMapLibFIS } from './fis'

export default class FlightViewMapLib {
  // submodule
  module: FlightViewMapLibTracker | FlightViewMapLibATM | FlightViewMapLibWL | FlightViewMapLibFIS

  // init
  custId: string
  toolId: string
  locale: string
  layout: string

  initialize(props: InitProps) {

    this.layout = props.tracker?.layout
    if (this.layout && this.layout === '2023v1') {      
      import("./css/flightmap2023V1.css");
    }

    this.custId = props.custId
    this.toolId = props.toolId
    const element = document.getElementById(props.container)
    // following empty element is for FVAccess compatibility
    element.appendChild(createElement('socialIcons1', 'none'))
    // following empty element is for FVAccess compatibility
    element.appendChild(createElement('socialIcons2'))
    this.locale = props.locale || 'en'
    initializeTranslations(this.locale).then(() => {
      if (props.type === 'tracker' && props.tracker) {
        this.module = new FlightViewMapLibTracker(element, props)
        if (props.tracker.iFrameBelowMapEnabled || props.tracker.iFrameBelowMapSrc) {
          const iframeElement = document.createElement('iframe')
          iframeElement.id = 'iframeBelowMap'
          iframeElement.className = 'iframeBelowMap'
          iframeElement.style.border = '0'
          element.appendChild(iframeElement)
        }
      } else {
        if (props.type === 'atm' && props.atm) {
          this.module = new FlightViewMapLibATM(element, props)
          fvAtmInitSignal(props.custId, props.toolId)
        }
        if (props.type === 'wl' && props.wl) {
          this.module = new FlightViewMapLibWL(element, props)
          fvWlInitSignal(props.custId, props.toolId)
        }
        if (props.type === 'fis' && props.fis) {
          this.module = new FlightViewMapLibFIS(element, props)
        }
      }
    }).catch((err) => {
      console.error('Cannot initialize translations', err)
    })
  }
}
